import { render, staticRenderFns } from "./ManageServiceOrderRating.vue?vue&type=template&id=247f473f&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ManageServiceOrderRating.vue?vue&type=style&index=0&id=247f473f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247f473f",
  null
  
)

export default component.exports